import { render, staticRenderFns } from "./AttributeLibrary.vue?vue&type=template&id=ea1f22fa&scoped=true"
import script from "./AttributeLibrary.vue?vue&type=script&lang=ts"
export * from "./AttributeLibrary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1f22fa",
  null
  
)

export default component.exports